import React, { useRef, useState } from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const ListedBy = ({ data, cms, coList, state }) => {
  const isRhss = data.listingAgentEmailId?.includes("@rhss.com");
  const address1 = `${data.listingAgentAddress1} ${data.listingAgentAddress2}`;
  const address2 = `${data.listingAgentCity}, ${data.listingAgentState} ${data.listingAgentZip}`;
  //   const tooltipRefBid = React.createRef();
  //   const [show, setShow] = useState(false);

  // const rhssHeader = cms.RHSSComplianceText.split('<br>')[0];
  // const rhssContent = cms.RHSSComplianceText.split('<br>')[1];


  const renderRhss = () => {
    return (
      <div>

        <div className="row ">
          <p className="pdpHeadingMedium wa" tabIndex="0" style={{ width: '50%' }}>
            Main Location {" "}
          </p>
          <p className="pdpText wa" tabIndex="0">Atlanta, GA
          </p>
        </div>


        <p>
          <p className="listedByStaticTxt" tabIndex="0" >
            <span style={{ color: '#118bf4' }}>
              REALHome Services and Solutions, Inc.
            </span>



            is a licensed real estate brokerage in 49 states plus Washington
            D.C. and its affiliate, REALHome Services and Solutions - CT, Inc.,
            is a licensed real estate brokerage in Connecticut.

          </p>

        </p>
      </div>
    );
  };
  const renderDefaultAddress = () => {
    return (
      <div>
        {(data.listingAgentAddress1 !== "-" ||
          data.listingAgentAddress2 !== "-") && <p>{address1}</p>}
        {(data.listingAgentCity !== "-" ||
          data.listingAgentState !== "-" ||
          data.listingAgentZip !== "-") && <p>{address2}</p>}
      </div>
    );
  };
  const renderStateAddress = () => {
    var stateData =
      data && data.listingAgentState ? data.listingAgentState : "";
    return (
      <div>
        <p>{stateData}</p>
      </div>
    );
  };

  return (
    <div className="left_side_widget mb30 tour-pdp-details p0">
      <Row className="propertyInfoBoxHeading p0">

        {state === "NC" ? (
          <h3 className='propertyInfoBoxHeadingText' tabIndex="0" >
            Traditional Real Estate Broker:
          </h3>

        ) : (
          <h3 className='propertyInfoBoxHeadingText' tabIndex="0" >{coList && "Co-"}Listed By:</h3>
        )}


      </Row>

      <div className="p30">
        <div>

          {
            <div className="row ">
              <p className="pdpHeadingMedium wa"
              tabIndex="0"
              style={{width: '50%'}}
                >
                  <span
                   data-tooltip-id="listedByAgentToolTip"
                data-tooltip-place="bottom"
                 style={{ display: 'inline-block', cursor: 'pointer'  }}
                data-tooltip-content="A listing agent is a real estate agent that assists the seller in listing and selling the property."
               >
                     Agent {" "}
                  </span>
                   


              </p>
              <Tooltip id="listedByAgentToolTip" place="bottom"

                style={{ fontSize: 11, width: 200, zIndex: 9999, lineHeight:1.5 }} />
               
      
              <p className="pdpText wa" tabIndex="0">
                {(data.listingAgentFirstName &&
                  data.listingAgentFirstName != "-") ||
                  (data.listingAgentLastName && data.listingAgentLastName != "-")
                  ? `${data.listingAgentFirstName} ${data.listingAgentLastName}`
                  : !data.listingAgentLicenseNumber || data.listingAgentLicenseNumber == "-" ? "" : "Contact Agent for details"}
              </p>
            </div>
          }


        </div>

        {data.listingAgentLicenseNumber && data.listingAgentLicenseNumber != "-" &&
          <div className="row ">
            <p className="pdpHeadingMedium wa" tabIndex="0" style={{ width: '50%' }}>
              License Number{" "}
            </p>
            <p className="pdpText wa" tabIndex="0">
              {data.listingAgentLicenseNumber &&
                data.listingAgentLicenseNumber != "-"
                ? `${data.listingAgentLicenseNumber}`
                : ""}

            </p>
          </div>
        }
        {
          !data.listingAgentLicenseNumber ||
          data.listingAgentLicenseNumber == "-" &&
          <div>
            <p className="pdpText wa" tabIndex="0">
              Contact Agent for details

            </p>
          </div>
        }




        {data.agency && data.agency != "-" &&
          <div className="row ">
            <p className="pdpHeadingMedium wa mb-0" tabIndex="0" style={{ width: '100%' }}>
              Corporation {" "}
            </p>
            <p className="pdpText wa" tabIndex="0">{data.agency && data.agency != "-" ? `${data.agency}` : "-"}
              {/* <p> {data.listingAgentPhone &&
                data.listingAgentPhone != null &&
                data.listingAgentPhone != "-"
                ? ` ${data.listingAgentPhone}`
                : ""}</p> */}

            </p>
          </div>
        }
        {isRhss && !coList && renderDefaultAddress()}
        {!isRhss && coList ? renderStateAddress() : null}
        {data?.listingAgentPhone?.length > 0 &&
          <div className="row ">
            <p className="pdpHeadingMedium wa" tabIndex="0" style={{width:'50%'}}>
              Phone Number
            </p>
            <p className="pdpText wa" tabIndex="0">
              {data.listingAgentPhone &&
                data.listingAgentPhone != null &&
                data.listingAgentPhone != "-"
                ? ` ${data.listingAgentPhone}`
                : "-"}
            </p>

          </div>
        }

        {isRhss ? renderRhss() : null}
      </div>
    </div>
  );
};

export default ListedBy;
